export default __webpack_public_path__ + "static/media/flag-malaysia.ce70530b.svg";